let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("7tnr1"), load("1xLoT")]).then(() => parcelRequire('kjSSV'));